import { Component } from '@angular/core'
import { MatTabsModule } from '@angular/material/tabs'
import { ReservaComprasTgComponent } from '../../features/reserva-compras/reserva-compras-tg/reserva-compras-tg.component'
import { ReservaComprasOsComponent } from '../../features/reserva-compras/reserva-compras-os/reserva-compras-os.component'

@Component({
  selector: 'reserva-compras',
  imports: [
    MatTabsModule,
    ReservaComprasTgComponent,
    ReservaComprasOsComponent,
  ],
  templateUrl: './reserva-compras.component.html',
  styleUrl: './reserva-compras.component.scss',
  standalone: true,
})
export class ReservaComprasComponent {}
